// 导入基本公共资源
import http from './../../../base/api/public'

let sysConfig = require('@/../config/sysConfig')
let apiPre = sysConfig.apiPre
let service = require('@/../config/serviceList')
export default {
  // 获取接口名称
  getInterfaceNames() {
    return http.requestPost(apiPre + service.res + '/res/cecInterfaceName/getInterfaceNames/', '')
  },
  // 获取接口名称(分页)
  getPage(params) {
    return http.requestPost(apiPre + service.res + '/res/cecInterfaceName/getList/', params)
  },
  // 接口信息入库
  insert(params) {
    return http.requestPost(apiPre + service.res + '/res/cecInterfaceName/insert', params)
  },
  getInterfaceById(params) {
    return http.requestPost(apiPre + service.res + '/res/cecInterfaceName/getInterfaceByID/' + params, '')
  },
  deleteInterfaceById(params) {
    return http.requestPost(apiPre + service.res + '/res/cecInterfaceName/deleteInterfaceByID/' + params, '')
  },
  update(params) {
    return http.requestPost(apiPre + service.res + '/res/cecInterfaceName/update/', params)
  }
}



// WEBPACK FOOTER //
// ./src/module/interactionCenter/api/interface.js